import Flex from "@irati/ui/src/Flex"
import {PointsBlend} from "@irati/ui/src/Logos"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedNumber} from "@irati/utils/lang"
import React from "react"

export function WalletsBalance({balance}: {balance: number}): JSX.Element {
  return (
    <Flex gap={1} alignItems="center">
      <H2>
        <FormattedMessage id="wallet.intro.totalBalance" />
      </H2>
      <PointsBlend />
      <H2>
        <FormattedNumber value={balance} />
      </H2>
    </Flex>
  )
}
